<template>
    <div id="niceAndNeat">
        <div id="tradingGroupOveriew" class="row">
            <div class="e-card">
                <div class="row">
                    <div id="tradingGroupInfo" class="col-lg-8" style="padding: 2%;">
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='contractNames' name="contractNames" :multiline="true" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.contractNames" placeholder="Contracts"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id='startDate' name="startDate" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.startDate" placeholder="Start Date" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='country' name="country" :disabled="true" width="80%" floatLabelType="Auto" v-model="countryName" placeholder="Country" @change="checkCountry"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-datepicker id='endDate' name="endDate" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.endDate" placeholder="End Date" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                            </div>
                        </div>
                      
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='utility' name="utility" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.utility" placeholder="Utility"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='supplier' name="supplier" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.supplier" placeholder="Supplier"></ejs-textbox>
                            </div>
                        </div>
                       
                        <div class="form-row">
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='annualVolume' name="annualVolume" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.annualVolume" placeholder="Annual Volume" format="n2"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group">
                                <ejs-textbox id='alerts' name="alerts" :disabled="true" width="80%" floatLabelType="Auto" v-model="data.alerts" placeholder="Alerts"></ejs-textbox>
                            </div>
                            <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSectionPosition">
                                <ejs-textbox id='pricingAreaNames' name="pricingAreaNames" :disabled="true" width="80%" floatLabelType="Auto" v-model='pricingAreaNames' placeholder="Price Areas"></ejs-textbox>
                            </div>
                        </div>
                    </div>
                    <div id="buttons" class="col-lg-4 pt-5">
                        <div class="form-row">
                            <div class="col mt-5 mb-2 d-flex justify-content-center">
                                <ejs-button cssClass="e-primary" v-on:click.native='btnDownloadFullReport'>Full Position Report</ejs-button>
                            </div>

                        </div>
                        <div class="form-row">
                            <div class="col mt-3 mb-4 d-flex justify-content-center">
                                <ejs-button cssClass="e-primary" v-on:click.native='btnDownloadPositionReport'>Position Summary</ejs-button>
                            </div>
                        </div>
                     
                    </div>
                </div>
            </div>
        </div>
        <div id="PositionData" class="row">
            <div class="e-card mt-2">
                <div class="form-group">
                    <div class="col-sm-2 m-2">
                        <ejs-dropdownlist id="dplReportingView" name="dplReportingView" ref="reportingView" :dataSource='reportingView' :fields="{text: 'name', value: 'id' }" :select='onReportViewSelect' placeholder="Reporting View" floatLabelType='Auto'></ejs-dropdownlist>
                    </div>
                    <div class="col-sm-3 m-2  d-flex">
                        <ejs-dropdownlist ref='dplCurrency' id="currency" name="currency" v-model="data.currencyId" :change="onCurrencyChange" :dataSource='currencies' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :showClearButton='true'></ejs-dropdownlist>
                        <ejs-checkbox cssClass="postionCheck check-d" :change="onCheckPostionDefault" label='Default Mechanism' id="positionSummaryCheck" name="checkName" floatLabelType='Auto'></ejs-checkbox>
                    </div>
              
                </div>
                <div class="row">
                    <div class="col m-3">
                        <ejs-grid ref='grid'
                                  :dataSource='gridData'
                                  :allowPaging='false'
                                  :allowResizing='true'
                                  :allowReordering='false'
                                  :allowSorting='false'
                                  :autoFit='false'
                                  :queryCellInfo='customiseCell'>
                            <e-columns>
                                <e-column field='yearName' headerText='Year' width=120></e-column>
                                <e-column field='totalContractedVolumeInContractTradingUnit' headerText='Total Contracted Volume' format="n2"></e-column>
                                <e-column headerText='FIXED' :columns='fixedColumns' textAlign="Center"></e-column>
                                <e-column headerText='OPEN' :columns='openColumns' textAlign="Center"></e-column>
                                <e-column headerText='M2M' :columns='m2mColumns' textAlign="Center"></e-column>
                                <e-column field='Reference' :columns='referenceColumns' textAlign="Center"></e-column>
                                <e-column field='Variance to Reference' :columns='varianceColumns' textAlign="Center"></e-column>
                                <e-column field='YoY' :columns='YoYColumns' textAlign="Center"></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
        <div id="additionalComponents">
            <div id="positionSpinner"></div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import apis from '../../../common/network'
    import urls from '../../../common/urls';
    import gridOptions from '../../../common/gridOptions'
    import store from '../../../store';
    import router from '../../../router/index';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
    import SyncHelper from '../../../common/syncfusion';


    Vue.use(ButtonPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);
    Vue.use(DropDownButtonPlugin);


    export default {
        name: 'PositionSummaryReport',
        created() {
        },
        data() {
            return {
                data: {},
                unit: null,
                currency: null,
                currencyId: null,
                value: null,
                firstIndexCurrency: 3,
                strategyDisabled: false,
                target: '#target',
                width: '250px',
                header: 'Dialog',
                visible: false,
                contractFileitems: [],
                strategyFileUrl: "",
                gridData: {},
                filterOptions: gridOptions.filterSettings,
                pageSettings: gridOptions.pageSettings,
                showPriceAreaSectionPosition: false,
                pricingAreaNames: "",
                countryName: null,
                reportingView: [{ "name": "CAL", "id": 1 }, { "name": "FIY", "id": 2 }, { "name": "12M", "id": 3 }],
                strategys: [{ "name": "Yes", "id": true }, { "name": "No", "id": false }],
                fixedColumns: [
                    {
                        field: 'fixedVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'fixedPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    }
                ],
                openColumns: [
                    {
                        field: 'openVolumePercentage',
                        headerText: 'Volume %',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    },
                    {
                        field: 'openPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    }
                ],
                m2mColumns: [
                    {
                        field: 'm2mPrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'm2mValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                referenceColumns: [
                    {
                        field: 'referencePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'referenceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                varianceColumns: [
                    {
                        field: 'variancePrice',
                        headerText: 'Price',
                        textAlign: 'Center',
                        width: "120",
                        format: "n3"
                    },
                    {
                        field: 'varianceValue',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    }
                ],
                YoYColumns: [
                    {
                        field: 'yoyDifferencePrice',
                        headerText: 'Value',
                        textAlign: 'Center',
                        width: "120",
                        format: "n0"
                    },
                    {
                        field: 'yoyDifferencePercentage',
                        headerText: '%',
                        textAlign: 'Center',
                        width: "120",
                        format: "n1"
                    }
                ],

            }
        },
        computed: {
            currencies() {
                return SyncHelper.getDataManager("utils/currenciesAvailable?tradingGroupId=" + store.state.reportTradingGroupId);
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('positionSpinner')
            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById('positionSpinner'));
            this.$refs.reportingView.ej2Instances.value = 1;
            this.getPositionData("CAL");
            this.getContractData();
        },
        methods: {
            btnDownloadFullReport: function (e) {
                showSpinner(document.getElementById('positionSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateFullTradingGroupReport/${store.state.reportTradingGroupId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('positionSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('positionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            },
            onCurrencyChange: function (args) {

                this.currencyId = args.itemData.currencyId;
                let selected = document.getElementById('dplReportingView').value;
                this.getPositionData(selected, this.currencyId);

            },
            onCheckPostionDefault: function (args) {

                store.state.isCheckDefaultM = args.checked;

                let selected = document.getElementById('dplReportingView').value;
                this.currencyId = this.$refs.dplCurrency.ej2Instances.value;
                this.getPositionData(selected, this.currencyId);
            },
            btnDownloadPositionReport: function (e) {
                showSpinner(document.getElementById('positionSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateTradingGroupIdPositionReportPage/${store.state.reportTradingGroupId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('positionSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    response => {
                        hideSpinner(document.getElementById('positionSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );
            },
            onViewContractClick: function (e) {
                showSpinner(document.getElementById('positionSpinner'));
                router.push({ name: "PDFViewer", params: { fileName: e.item.id } });
            },
            onViewStrategyClick: function (e) {
                showSpinner(document.getElementById('positionSpinner'));
                router.push({ name: "PDFViewer", params: { fileName: this.strategyFileUrl.split(/[\s/]+/).pop() } });
            },
            getContractData() {
                apis.protectedApi(`tradingGroup/overview?tradingGroupId=${store.state.reportTradingGroupId}`)
                    .then(response => {
                        if (response.data) {
                            this.showPriceAreaSectionPosition = response.data.pricingAreaNames != "" ? true : false;
                            this.pricingAreaNames = response.data.pricingAreaNames;
                            if (response.data.pricingAreaNames != "") {
                                store.state.pricingAreaNames = response.data.pricingAreaNames;
                            } else {
                                store.state.pricingAreaNames = undefined;
                            }
                        }
                    }).catch(e => {
                        this.showErrorDialog("Something went wrong, please contact support.");
                    });
            },
            getContractUrl: function (contractFileUrls) {
                var items = [];
                let input = contractFileUrls ? contractFileUrls.split(",") : [];
                for (let index in input) {
                    items.push({ text: input[index].split(/[\s/]+/).pop().slice(0, -4), id: input[index].split(/[\s/]+/).pop() });
                }
                return items;
            },
            getPositionData: function (reportView, currencyId) {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`report/tradingGroupPositionsummary/${store.state.reportTradingGroupId}?reportView=${reportView}&currencyId=${currencyId == undefined ? "" : currencyId}&defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}`)
                    .then(response => {
                        hideSpinner(document.getElementById('positionSpinner'));
                        const countryId = document.getElementById('country').value;
                        if (countryId != null && countryId != '') {
                            hideSpinner(document.getElementById('mainSpinner'));
                        }
                        this.data = response.data.result;
                        this.unit = response.data.unit;
                        this.currency = response.data.currency;
                        this.value = response.data.value;
                        this.gridData = response.data.result.calendarPositionData;
                        this.countryName = response.data.result.country;

                        if (response.data.value == 'p/therm') {

                            this.$refs.dplCurrency.ej2Instances.text = "p - GBp";

                        } else {

                            this.$refs.dplCurrency.ej2Instances.text = response.data.currencySymbolAndName;
                        }
                        
                    }).catch(e => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        hideSpinner(document.getElementById('positionSpinner'));
                        if (e.response) {
                            hideSpinner(document.getElementById('mainSpinner'));
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            onReportViewSelect: function (args) {
                let selected = args.itemData.name;
                this.getPositionData(selected);
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            customiseCell: function (args) {
                if (args.column.field === 'totalContractedVolumeInContractTradingUnit' || args.column.field === 'openVolumeInContractTradingUnit') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.unit;
                } else if (args.column.field === 'fixedVolumePercentage' || args.column.field === 'openVolumePercentage') {
                    args.cell.textContent = args.cell.textContent + ' ' + "%";
                } else if (args.column.field === 'fixedPrice' || args.column.field === 'openPrice' || args.column.field === 'm2mPrice' || args.column.field === 'referencePrice' || args.column.field === 'variancePrice') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.value;
                } else if (args.column.field === 'referenceValue' || args.column.field === 'openValue' || args.column.field === 'm2mValue' || args.column.field === 'fixedValue' || args.column.field === 'yoyDifferencePrice' || args.column.field === 'varianceValue') {
                    args.cell.textContent = args.cell.textContent + ' ' + this.currency;
                }
            },
            checkCountry() {
                const countryId = document.getElementById('country').value;
                if (countryId != null && countryId != '') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            }
        }
    }
</script>

<style scoped>
</style>
<style>
    .volume-unit {
        width: 100%;
        padding-left: 5px;
    }
    .postionCheck {
        margin: 25px 36px 0px 5px !important;
    }
    #positionSpinner {
        display: none;

    }

</style>